import { motion } from "framer-motion";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";

const faqs = [
    {
        q: "Hoe snel ontvang ik mijn video?",
        a: "De levering is tussen de 1 tot 3 werkdagen.",
    },
    {
        q: "Welke bestanden moet ik aanleveren?",
        a: "Stuur de vastgoedfoto's in de hoogste resolutie via WeTransfer of Smash. Voeg eventueel je logo en extra info toe zoals gewenste videoformaten: horizontaal of verticaal.",
    },
    {
        q: "Welke platformen zijn geschikt?",
        a: "Onze video's zijn geschikt voor Instagram, TikTok, Facebook, websites en vastgoedplatformen.",
    },
    {
        q: "Heeft u nog andere vragen?",
        a: "Stuur gerust een mail naar marlea.agency@gmail.com.",
    },
];

export const FAQ = () => {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative py-28 md:py-40 bg-white"
        >
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="mb-12"
                >
                    <p className="text-[11px] font-bold tracking-[0.3em] uppercase text-neutral-500 mb-5">
                        / 05 — FAQ
                    </p>
                    <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-black leading-[1.02]">
                        Veelgestelde vragen.
                    </h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.1 }}
                >
                    <Accordion
                        type="single"
                        collapsible
                        className="divide-y divide-black/10 border-t border-b border-black/10"
                    >
                        {faqs.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                className="border-0"
                                data-testid={`faq-item-${i}`}
                            >
                                <AccordionTrigger className="py-6 text-left font-heading text-base md:text-xl font-semibold text-black tracking-tight hover:no-underline hover:text-neutral-700 transition-colors">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-6 text-sm md:text-base text-neutral-600 leading-relaxed">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </motion.div>
            </div>
        </section>
    );
};
